/**
 * Restaurant menu data.
 *
 * This mirrors the planned Supabase tables (menu_categories / menu_items) so
 * the UI will not need to change when data moves to the database.
 *
 * NO REAL PRODUCTS YET: `menuItems` is intentionally empty until the owner
 * supplies the real menu. Never add invented dishes or prices here.
 *
 * MenuItem shape:
 * {
 *   id:            string   unique, e.g. "pizza-margherita"
 *   name:          string
 *   description:   string
 *   price:         number | null   EUR, e.g. 14.5 (null shows "Price to be confirmed")
 *   category:      string   a category `slug` below
 *   image:         { src: string, alt: string } | null
 *   allergens:     number[] codes from ALLERGENS (1–14)
 *   available:     boolean  false shows "Currently unavailable"
 *   featuredLabel: string | null   optional badge, e.g. "Chef's pick"
 *   sortOrder:     number
 * }
 */

/** Display order = array order (later: menu_categories.sort_order). */
export const menuCategories = [
  { slug: "starters", name: "Starters" },
  { slug: "wood-fired-pizza", name: "Wood-Fired Pizza" },
  { slug: "wood-fired-panuozzo", name: "Wood-Fired Panuozzo" },
  { slug: "burgers", name: "Burgers" },
  { slug: "wraps", name: "Wraps" },
  { slug: "kebab-bowls", name: "Kebab Bowls" },
  { slug: "grill", name: "Grill" },
  { slug: "baskets", name: "Baskets" },
  { slug: "sides", name: "Sides" },
  { slug: "dips", name: "Dips" },
  { slug: "specials", name: "Specials" },
];

/**
 * The 14 allergens that must be declared under EU Regulation 1169/2011,
 * numbered as commonly used on Irish menus.
 */
export const ALLERGENS = {
  1: "Cereals containing gluten",
  2: "Crustaceans",
  3: "Eggs",
  4: "Fish",
  5: "Peanuts",
  6: "Soybeans",
  7: "Milk",
  8: "Nuts",
  9: "Celery",
  10: "Mustard",
  11: "Sesame seeds",
  12: "Sulphur dioxide and sulphites",
  13: "Lupin",
  14: "Molluscs",
};

/** Real menu items go here (or come from Supabase later). */
export const menuItems = [];

/** Groups items by category in category order, dropping empty categories. */
export function groupMenu(items, categories = menuCategories) {
  return categories
    .map((category) => ({
      ...category,
      items: items
        .filter((item) => item.category === category.slug)
        .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0)),
    }))
    .filter((group) => group.items.length > 0);
}

export const formatMenuPrice = (price) =>
  typeof price === "number"
    ? new Intl.NumberFormat("en-IE", { style: "currency", currency: "EUR" }).format(price)
    : null;
